import { HTMLAttributes } from 'react'

import Typography from '@/components/base/typography'

import StoreCard from './StoreCard'
import { cn } from '@/lib/utils'
import { SalesPoint, SalesPointCategory } from '@/types/sales-network'

export type StoreListProps = Omit<
  HTMLAttributes<HTMLDivElement>,
  'onSelect'
> & {
  stores: SalesPoint[]
  categories?: SalesPointCategory[]
  selectedStore?: SalesPoint | null
  onStoreSelect?: (_store: SalesPoint) => void
  emptyMessage?: string
}

const StoreList = ({
  stores,
  categories = [],
  selectedStore,
  onStoreSelect,
  emptyMessage,
  className,
  ...props
}: StoreListProps) => {
  if (stores.length === 0) {
    return (
      <div
        className={cn(
          'border-t border-[rgba(255,255,255,0.1)] pb-spacing-lg pt-spacing-xs',
          className
        )}
        {...props}
      >
        <Typography
          variant="large"
          component="h3"
          className="text-text-heading-dark"
        >
          {emptyMessage}
        </Typography>
      </div>
    )
  }

  return (
    <div
      className={cn(
        'grid grid-cols-1 border-t border-[rgba(255,255,255,0.1)] md:grid-cols-2 lg:grid-cols-1',
        className
      )}
      {...props}
    >
      {stores.map((store) => (
        <StoreCard
          key={store.id}
          store={store}
          categories={categories}
          isSelected={selectedStore?.id === store.id}
          onSelect={onStoreSelect}
        />
      ))}
    </div>
  )
}

export default StoreList
